module.exports = __webpack_public_path__ + "assets/c3ba01c372a34ce72fa8ba2144c48b29.png";